import { useEffect } from 'react';
import { NavigationType, useLocation, useNavigationType } from 'react-router-dom';

const useBackButton = () => {
  const navType = useNavigationType();
  return navType === NavigationType.Pop;
}

const ScrollToTop = (props) => {
  const {pathname} = useLocation();
  const {isPop} = useBackButton();
  useEffect(() => {
    window.scrollTo(0,0);
  }, [pathname, isPop]);
  return <>{props.children}</>;
}

export default ScrollToTop;